import { Box, Divider, List, Typography } from "@mui/material";
import { ChangePassword } from "./changePassword";
import { RestoreDataSettings } from "./restoreDataSettings";

export const SectionMyAccount = () => {
  return (
    <Box component="div">
      <Box component="div" sx={{ marginBottom: "25px", paddingX: "20px" }}>
        <Typography variant="h6" sx={{ fontWeight: "bold" }}>
          Mi Cuenta
        </Typography>
        <Typography variant="subtitle2">
          Administre la configuración de su cuenta desde la sección a
          continuación.
        </Typography>
      </Box>
      <List
        sx={{
          border: "1px solid rgba(7,9,25,.125)",
          borderRadius: "0.65rem",
        }}
      >
        {/* <ListItem
          secondaryAction={
            <IconButton>
              <BiEdit />
            </IconButton>
          }
        >
          <ListItemIcon>
            <IconContext.Provider value={{ className: "text-4xl" }}>
              <FaUserEdit />
            </IconContext.Provider>
          </ListItemIcon>
          <ListItemText
            primary="Cambiar datos de usuario"
            secondary="Puede cambiar algunos datos como nombre de usuario , correo , etc."
          />
        </ListItem> */}
        <Divider variant="inset" component="li" />
        <ChangePassword />
        <RestoreDataSettings />
      </List>
    </Box>
  );
};
